{
  "button.goBack": "Go Back",
  "footer.copyright": "Copyright {0} Pearson Education Inc. or its affiliate(s). All rights reserved.",
  "footer.terms": "Terms",
  "footer.privacy": "Privacy",
  "error.invalidCharacter": "Invalid character",
  "label.aria.clearSearchValue": "Clear search value",
  "label.aria.closeNavMenu": "Close navigation menu",
  "label.aria.dismissToast": "Dismiss toast",
  "label.aria.openNavMenu": "Open navigation menu",
  "label.aria.remove": "remove {0}"
}
